import {RadioGroup} from '../RadioGroup';

export class SingleChoiceQuestion {
  constructor(questionNode, onChange) {
    var groups = Array.from(questionNode.querySelectorAll('[role="radiogroup"]'));
    this.radioGroups = groups.map((group) => {
      var radioDomNodes = Array.from(group.querySelectorAll('[role="radio"]'));
      return new RadioGroup(radioDomNodes, onChange);
    });
  }
}
